import api from "@/lib/axios";

const getErrorMessage = (error, fallback) =>
  error.response?.data?.message || error.message || fallback;

const buildTemplatePayload = (templateData) => ({
  name: templateData.name?.trim(),
  channel: templateData.channel || "email",
  subject: templateData.subject?.trim() || templateData.name?.trim() || "",
  body: templateData.body?.trim() ?? templateData.email_body?.trim() ?? "",
  sms_body: templateData.sms_body?.trim() ?? "",
});

export const marketingCampaignService = {
  getCampaigns: async (params = {}) => {
    try {
      const response = await api.get("/marketing/templates", { params });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to fetch templates"));
    }
  },

  getCampaign: async (templateId) => {
    try {
      const response = await api.get(`/marketing/templates/${templateId}`);
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to fetch template"));
    }
  },

  createCampaign: async (templateData) => {
    try {
      const response = await api.post(
        "/marketing/templates",
        buildTemplatePayload(templateData),
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to create template"));
    }
  },

  updateCampaign: async (templateId, templateData) => {
    try {
      const response = await api.put(
        `/marketing/templates/${templateId}`,
        buildTemplatePayload(templateData),
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to update template"));
    }
  },

  deleteCampaign: async (templateId) => {
    try {
      const response = await api.delete(`/marketing/templates/${templateId}`);
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to delete template"));
    }
  },
};
